/* Changes only product-card offer text; never alters prices, forms or selections. */
(function () {
  'use strict';
  var selector = '[data-lp-card-offer]';
  var scheduled = false;
  var sizeObserver = null;
  var observedWidths = new WeakMap();
  var claimKey = 'lpHalloween2026Claim';
  var disabledKey = 'lpCardOfferDisabled';
  var code = 'LUMA20';
  var claimed = false;
  var saved = false;
  var disabled = false;
  var stateVersion = 0;
  var reading = false;
  var checkedCart = false;

  function known(value) { return String(value || '').trim().toUpperCase() === code; }
  function loadState() {
    try {
      claimed = known(JSON.parse(localStorage.getItem(claimKey) || 'null')?.code);
      disabled = localStorage.getItem(disabledKey) === code;
    } catch (_) {}
    try { saved = known(sessionStorage.getItem('lpProductDiscountCode')); } catch (_) {}
    try {
      var cookie = document.cookie.split('; ').find(function (value) { return value.startsWith('discount_code='); });
      saved = saved || known(decodeURIComponent(cookie ? cookie.slice('discount_code='.length) : ''));
    } catch (_) {}
  }
  function setDisabled(value) {
    disabled = value;
    try { value ? localStorage.setItem(disabledKey, code) : localStorage.removeItem(disabledKey); } catch (_) {}
  }
  function cartHasOffer(cart) {
    // A submitted/claimed offer can preview savings even with an empty cart.
    // An unrecognised URL parameter alone does not unlock any offer.
    if ((cart?.discount_codes || []).some(function (entry) { return known(typeof entry === 'string' ? entry : entry.code); })) return true;
    var applications = (cart?.cart_level_discount_applications || []).slice();
    (cart?.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) { applications.push(allocation.discount_application); });
    });
    return applications.some(function (entry) { return entry?.type === 'discount_code' && known(entry.title); });
  }
  async function readCart(force) {
    if (reading || checkedCart && !force || !document.querySelector('[data-lp-card-offer], [data-lp-card-native], [data-lp-card-recent]')) return;
    reading = true;
    checkedCart = true;
    var version = stateVersion;
    try {
      var root = window.Shopify?.routes?.root || '/';
      var response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000) });
      if (!response.ok) return;
      var cart = await response.json();
      if (version !== stateVersion) return;
      if (cartHasOffer(cart)) {
        // A fresh discount link may reapply an offer previously removed by
        // this visitor. Only a current cart response can override that opt-out;
        // an old claim or cookie cannot.
        setDisabled(false);
        saved = true;
        try { sessionStorage.setItem('lpProductDiscountCode', code); } catch (_) {}
        schedule();
      }
    } catch (_) { /* Keep the original price when no offer state is available. */ }
    finally { reading = false; }
  }
  function reveal(node, show) {
    if (!node) return;
    if (node.hidden !== !show) node.hidden = !show;
    if (show) { if (node.style.getPropertyValue('display') === 'none') node.style.removeProperty('display'); }
    else if (node.style.getPropertyValue('display') !== 'none') node.style.setProperty('display', 'none');
  }
  function prepareRecentCards() {
    var catalogNode = document.querySelector('[data-lp-card-catalog]');
    if (!catalogNode) return;
    var catalog;
    try { catalog = JSON.parse(catalogNode.textContent); } catch (_) { return; }
    document.querySelectorAll('[data-lp-card-recent]').forEach(function (card) {
      var minimum = Number(catalog[card.dataset.lpProductId]);
      if (!Number.isFinite(minimum) || minimum <= 0 || card.hasAttribute('data-lp-card-offer')) return;
      // Reuse the original node: recent-history entries need no migration, and
      // titles, links, images and the saved product data remain untouched.
      card.className = 'lp-card-offer';
      card.setAttribute('data-lp-card-offer', '');
      card.setAttribute('data-lp-min-config-usd', String(minimum));
      card.innerHTML = '<div class="lp-card-offer__row"><span class="lp-card-offer__current" data-lp-offer-current></span><s class="lp-card-offer__original" data-lp-offer-original hidden style="display:none"></s></div><div class="lp-card-offer__saving" data-lp-offer-details hidden style="display:none">Save <span data-lp-offer-saving></span></div>';
      reveal(card, false);
    });
  }

  function fitPriceRow(offer) {
    var row = offer.querySelector('.lp-card-offer__row');
    if (!row || !row.clientWidth || offer.hidden) return;
    // Reset before measuring so a wider card can recover its normal font size.
    row.style.removeProperty('font-size');
    row.style.removeProperty('flex-wrap');
    var style = window.getComputedStyle(row);
    var baseSize = parseFloat(style.fontSize);
    var gap = parseFloat(style.columnGap) || 0;
    var children = Array.prototype.slice.call(row.children);
    var textWidth = children.reduce(function (width, child) {
      return width + child.getBoundingClientRect().width;
    }, 0);
    var available = row.clientWidth - gap * Math.max(0, children.length - 1);
    if (!baseSize || !textWidth || textWidth <= available) return;
    var fittedSize = Math.floor(baseSize * available / textWidth * 10) / 10;
    // An exceptionally narrow card can wrap rather than clip or use tiny text.
    if (fittedSize < 10) {
      row.style.flexWrap = 'wrap';
    } else {
      row.style.fontSize = fittedSize + 'px';
    }
  }

  function update() {
    scheduled = false;
    prepareRecentCards();
    var unlocked = !disabled && (claimed || saved);
    document.querySelectorAll('[data-lp-card-native]').forEach(function (card) {
      reveal(card.querySelector('[data-lp-card-base]'), !unlocked);
      reveal(card.querySelector('[data-lp-card-sale]'), unlocked);
    });
    var currency = window.Shopify && window.Shopify.currency;
    var active = currency && String(currency.active || '').toUpperCase();
    var rate = active === 'USD' ? 1 : Number(currency && currency.rate);
    var canFormat = active && Number.isFinite(rate) && rate > 0 && window.LPMoney;
    document.querySelectorAll(selector).forEach(function (offer) {
      if (sizeObserver && !observedWidths.has(offer)) {
        observedWidths.set(offer, offer.clientWidth);
        sizeObserver.observe(offer);
      }
      if (!canFormat) {
        // USD is already rendered by Liquid; do not leave an unlocked price
        // behind after a removal if the currency formatter is unavailable.
        if (offer.dataset.lpOfferOriginalText) {
          var current = offer.querySelector('[data-lp-offer-current]');
          current.textContent = unlocked ? offer.dataset.lpOfferDiscountText : offer.dataset.lpOfferOriginalText;
        }
        reveal(offer.querySelector('[data-lp-offer-original]'), unlocked);
        reveal(offer.querySelector('[data-lp-offer-details]'), unlocked);
        fitPriceRow(offer);
        return;
      }
      var minimum = Number(offer.getAttribute('data-lp-min-config-usd'));
      if (!Number.isFinite(minimum) || minimum <= 0) return;
      var original = Math.round(minimum * rate);
      var discounted = Math.round(original * 0.8);
      var amounts = { current: unlocked ? discounted : original, saving: original - discounted, original: original };
      Object.keys(amounts).forEach(function (key) {
        var node = offer.querySelector('[data-lp-offer-' + key + ']');
        if (!node) return;
        var formatted = window.LPMoney.format(amounts[key], {
          currency: active, locale: document.documentElement.lang || 'en'
        });
        if (node.textContent !== formatted) node.textContent = formatted;
      });
      offer.dataset.lpOfferOriginalText = window.LPMoney.format(original, { currency: active, locale: document.documentElement.lang || 'en' });
      offer.dataset.lpOfferDiscountText = window.LPMoney.format(discounted, { currency: active, locale: document.documentElement.lang || 'en' });
      reveal(offer.querySelector('[data-lp-offer-original]'), unlocked);
      reveal(offer.querySelector('[data-lp-offer-details]'), unlocked);
      offer.hidden = false;
      offer.style.removeProperty('display');
      fitPriceRow(offer);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  function bind() {
    loadState();
    if (typeof ResizeObserver !== 'undefined') {
      sizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var width = entry.target.clientWidth;
          if (observedWidths.get(entry.target) !== width) {
            observedWidths.set(entry.target, width);
            schedule();
          }
        });
      });
    }
    update();
    readCart();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        var addedOffer = mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1 && (node.matches(selector + ', [data-lp-card-native], [data-lp-card-recent]') || node.querySelector(selector + ', [data-lp-card-native], [data-lp-card-recent]'));
          });
        });
        if (addedOffer) { schedule(); readCart(); }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', function () { loadState(); schedule(); readCart(true); });
    window.addEventListener('storage', function (event) {
      if (![claimKey, disabledKey, null].includes(event.key)) return;
      ++stateVersion; loadState(); schedule();
    });
    document.addEventListener('lp:card-offer-claimed', function (event) {
      if (!known(event.detail?.code)) return;
      ++stateVersion; claimed = true; setDisabled(false); schedule();
    });
    document.addEventListener('lp:discount-cart', function (event) {
      if (!event.detail || !Object.prototype.hasOwnProperty.call(event.detail, 'code')) return;
      ++stateVersion;
      saved = known(event.detail.code);
      setDisabled(!saved);
      schedule();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.cartData && cartHasOffer(event.cartData) && !disabled) { saved = true; schedule(); }
        else readCart(true);
      });
    }
    window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
